import { useCallback } from 'react';
import { ArcadeUser } from '../types/ArcadeUser';
import { useRefreshProfileMutation } from '../api';

export interface useArcadeUserProps {
  options?: {
    fixedCacheKey?: string;
  };
}

export const useArcadeUser = (props?: useArcadeUserProps) => {
  const options = props?.options;
  // TODO: Handle error with toast notification (or some other non-intrusive way)
  const [refreshProfile, refreshProfileResult] =
    useRefreshProfileMutation(options);
  const isLoading =
    refreshProfileResult?.isUninitialized || refreshProfileResult?.isLoading;
  const arcadeUser: ArcadeUser | undefined = refreshProfileResult?.data?.result;
  const loadArcadeUser = useCallback(
    (hardRefresh = false) => {
      refreshProfile({ hardRefresh });
    },
    [refreshProfile]
  );
  return {
    loadArcadeUser,
    arcadeUser,
    isLoading,
  };
};
export default useArcadeUser;
